/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentControllerReplaceRelatedDocumentsRequest { 
    /**
     * Conjunto completo de documentos relacionados. Los que no vengan se dan de baja; una lista vacía quita todos
     */
    relatedDocumentIds: Array<string>;
}

